module.exports = __webpack_public_path__ + "img/about_us_2.29a0b754.png";